import PropTypes from "prop-types"

export const documentType = PropTypes.shape({
  uuid: PropTypes.string,
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  date: PropTypes.number
})

export const documentsArray = PropTypes.arrayOf(documentType)

/**
 * Shape of data structure retrieve from /api/documents
 */
export const documentV2Type = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  formId: PropTypes.string,
  updatedAt: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  signable: PropTypes.bool,
  category: PropTypes.string,
  actions: PropTypes.shape({
    isEditable: PropTypes.bool,
    isSignable: PropTypes.bool,
    isDownloadable: PropTypes.bool
  })
})

export const documentV2ArrayType = PropTypes.arrayOf(documentType)

export const cardActionType = PropTypes.shape({
  Icon: PropTypes.object,
  label: PropTypes.string,
  onClick: PropTypes.func
})

export const cardActionsArray = PropTypes.arrayOf(cardActionType)
